import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const config = {
  apiKey: "AIzaSyDlEy5bBhMY8taDCBNTNP42Z3cwsH98-JE",
  authDomain: "marvans-ecom.firebaseapp.com",
  databaseURL:
    "https://marvans-ecom-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "marvans-ecom",
  storageBucket: "marvans-ecom.appspot.com",
  messagingSenderId: "418725500993",
  appId: "1:418725500993:web:caf52016ec0fb364e84ec0",
  measurementId: "G-BW65WVFM8K",
};

// Initialize Firebase
const firebaseConfig = config;

firebase.initializeApp(firebaseConfig);
export const database = firebase.firestore();
export const storage = firebase.storage();

export { firebase };
